<template>
  <div class="region" v-show="chooseRegion">
    <div class="regionContent">
      <div style="margin-top: 20px;">
        <img src="../assets/index/location.png" alt=""><span>{{data.city}}</span>
        <!--  <div class="light"></div> -->
      </div>
      <ul>
        <li v-for="(item,index) in area" @click="checked(item)">
          {{item.name}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        chooseRegion: false,
        area: []
      }
    },
    created() {
      // if (localStorage.getItem('type') == null && localStorage.getItem('token')) {
      //   this.chooseRegion = true
      // }
      // this.$http.getareaList().then(res => {
      //   this.area = res.data.list
      //   this.area.forEach(item => {
      //     item.checked = false
      //   })
      // })
    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    methods: {
      checked(item) {
        let name = item.name
        item.checked = true
        this.chooseRegion = false
        this.$http.subjectTypeList({
          province_id: item.id,
        }).then(res => {
          localStorage.setItem('province', name)
          localStorage.setItem('type', res.data.type)
          localStorage.setItem('select', res.data.select)
          this.$emit('reload', 111)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .regionContent {
    width: 800px;
    height: 400px;
    background: rgba(67, 64, 66, 1.0);
    left: 50%;
    position: absolute;
    top: 50%;
    margin-left: -300px;
    margin-top: -200px;
    color: #ffffff;
    font-size: 30px;

    img {
      width: 66px;
      height: 66px;
      vertical-align: middle;
      position: relative;
    }

    ul {
      margin: 20px;
    }

    ul li {
      font-size: 16px;
      float: left;
      margin: 10px;
      border: 1px solid #ffffff;
      padding: 10px;
      border-radius: 5px;
    }
  }

  .light {
    width: 10px;
    height: 74px;
    position: relative;
    top: -55px;
    left: -80px;
    transform: rotate(15deg);
    -webkit-transform: rotate(15deg);
    -webkit-animation: lighting 1.2s linear infinite forwards;
    -moz-animation: lighting 1.2s linear infinite forwards;
    animation: lighting 1.2s linear infinite forwards;
    background: rgba(255, 255, 255, .4);
    z-index: 1;
  }

  @-webkit-keyframes lighting {
    40% {
      left: -50px
    }

    100% {
      left: 300px
    }
  }

  ul li:hover {
    background-color: orange;
    cursor: pointer;
  }

  .region {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #000;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 10001;
  }
</style>



// WEBPACK FOOTER //
// src/components/region.vue